export default () => {
  return {
    wordsPerMinute: 225,
    readingTime: 0,
    calcReadingTime(text) {
      let words = text.trim().split(/\s+/).length
      this.readingTime = Math.ceil(words / this.wordsPerMinute)
    },
  }
}
